"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTable = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Api = __importStar(require("@src/api"));
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const queries_1 = require("@src/types/queries");
const dayjs_1 = __importDefault(require("dayjs"));
const ReportTable_style_1 = require("./ReportTable.style");
const useAnalyticTableColumnConfig_1 = require("./useAnalyticTableColumnConfig");
const ReportTable = ({ dateFrom, dateTo, analyticsType, reportStack, setReportStack, setTableAnalyticsType, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const reportStackAnalyticsItemByType = reportStack.find(stackItem => stackItem.type === analyticsType);
    const { data: tableData, isFetching } = (0, useAppQuery_1.useAppQuery)([queries_1.Queries.getAnalyticsData, dateFrom, dateTo, analyticsType], () => Api.Analytics.getAnalyticsByType({
        dateFrom: (0, dayjs_1.default)(dateFrom, 'D.M.YYYY').toISOString(),
        dateTo: (0, dayjs_1.default)(dateTo, 'D.M.YYYY').toISOString(),
        analyticsType,
        ...reportStackAnalyticsItemByType === null || reportStackAnalyticsItemByType === void 0 ? void 0 : reportStackAnalyticsItemByType.parameters,
    }));
    const tableProps = (0, useAnalyticTableColumnConfig_1.useAnalyticTableColumnConfig)({
        intl,
        analyticsType,
        setTableAnalyticsType,
        reportStack,
        setReportStack,
    });
    const dataSource = (0, useAnalyticTableColumnConfig_1.getTableDataSource)({
        tableData,
    });
    return (0, jsx_runtime_1.jsx)(ReportTable_style_1.StyledTable, { dataSource: dataSource, loading: isFetching, ...tableProps });
};
exports.ReportTable = ReportTable;
